export default __webpack_public_path__ + "static/media/icon-scheduled-gray.ca4769a8.svg";